<script>
import LoginComponent from '../features/LoginComponent';
import BrandLogo from '../../shared/BrandLogo.vue';

export default {
  name: 'LoginView',
  components: {
        'brand-logo': BrandLogo,
  },
  mixins: [LoginComponent],
  data() {
    return {
      showPassword: false,
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<template>
  <div class="login-page">
    <div class="login-page__background">
      <!-- Left side — branding panel -->
      <div class="login-page__branding">
        <div class="login-page__branding-content">
          <router-link
            to="/"
            class="login-page__logo-link"
          >
            <brand-logo
              variant="light"
              size="lg"
              stacked
            />
          </router-link>
          <div class="login-page__branding-text">
            <h1>Aprende a tu ritmo</h1>
            <p>Accede a cursos, simuladores y recursos educativos diseñados para tu desarrollo profesional.</p>
          </div>
        </div>
      </div>

      <!-- Right side — login form panel -->
      <div class="login-page__form-panel">
        <div class="login-page__card">
          <!-- Card header -->
          <div class="login-page__card-header">
            <div class="login-page__card-icon">
              <i class="uil uil-user-circle" />
            </div>
            <h2>Bienvenido</h2>
            <p>Ingresa con tu cuenta de <strong>AppMisionate</strong></p>
          </div>

          <!-- Form -->
          <el-form
            ref="formLogin"
            v-loading="isFormProcessing"
            :model="formLogin"
            :rules="rules"
            status-icon
            :label-position="'top'"
            :element-loading-text="formProcessingMessage"
            class="login-page__form"
          >
            <el-form-item
              label="Usuario o Correo"
              prop="username"
            >
              <el-input
                v-model="formLogin.username"
                auto-complete="off"
                placeholder="Ingresa tu usuario o correo electrónico"
                size="large"
              >
                <template #prefix>
                  <el-icon><User /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item
              label="Contraseña"
              prop="password"
            >
              <el-input
                v-model="formLogin.password"
                auto-complete="off"
                type="password"
                show-password
                placeholder="Ingresa tu contraseña"
                size="large"
                @keyup.enter="onLogin('formLogin')"
              >
                <template #prefix>
                  <el-icon><Lock /></el-icon>
                </template>
              </el-input>
            </el-form-item>

            <div class="login-page__options">
              <el-checkbox v-model="formLogin.rememberMe">
                Recordarme
              </el-checkbox>
              <router-link
                to="/recuperacion-password"
                class="login-page__forgot"
              >
                ¿Olvidaste tu contraseña?
              </router-link>
            </div>

            <el-form-item class="login-page__submit">
              <el-button
                type="primary"
                size="large"
                class="login-page__submit-btn"
                :loading="isFormProcessing"
                @click="onLogin('formLogin')"
              >
                <i class="uil uil-sign-in-alt" />
                Ingresar
              </el-button>
            </el-form-item>
          </el-form>

          <!-- Footer -->
          <div class="login-page__card-footer">
            <p>
              ¿No tienes una cuenta?
              <router-link to="/registrarse">
                Regístrate aquí
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ── Page Layout ── */
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  background: #f0f4f8;
}

.login-page__background {
  display: flex;
  width: 100%;
  min-height: 100vh;
}

/* ── Left Branding Panel ── */
.login-page__branding {
  flex: 1;
  background: linear-gradient(145deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  position: relative;
  overflow: hidden;
}

.login-page__branding::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
}

.login-page__branding-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 420px;
}

.login-page__logo-link {
  display: inline-block;
  margin-bottom: 40px;
}

.login-page__branding-text h1 {
  color: #ffffff;
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
  font-family: 'Roboto', sans-serif;
}

.login-page__branding-text p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 1rem;
  line-height: 1.7;
  font-family: 'Roboto', sans-serif;
}

/* ── Right Form Panel ── */
.login-page__form-panel {
  width: 520px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 32px;
  background: #f0f4f8;
}

/* ── Login Card ── */
.login-page__card {
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 30px -4px rgba(15, 23, 42, 0.12);
  overflow: hidden;
}

.login-page__card-header {
  padding: 32px 32px 24px;
  text-align: center;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
}

.login-page__card-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #EEF5FC, #D6E7F8);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.login-page__card-icon i {
  font-size: 28px;
  color: #0D47A1;
}

.login-page__card-header h2 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 6px;
  font-family: 'Roboto', sans-serif;
}

.login-page__card-header p {
  font-size: 0.875rem;
  color: #64748b;
  font-family: 'Roboto', sans-serif;
}

.login-page__card-header strong {
  color: #0D47A1;
}

/* ── Form ── */
.login-page__form {
  padding: 28px 32px 16px;
}

::v-deep .login-page__form .el-form-item {
  margin-bottom: 20px;
}

::v-deep .login-page__form .el-form-item__label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #334155;
  padding-bottom: 6px;
  font-family: 'Roboto', sans-serif;
}

::v-deep .login-page__form .el-input--large .el-input__wrapper {
  padding: 6px 14px;
  border-radius: 10px;
  min-height: 44px;
  box-shadow: 0 0 0 1px #cbd5e1 inset;
  transition: all 0.2s ease;
}

::v-deep .login-page__form .el-input--large .el-input__wrapper:hover {
  box-shadow: 0 0 0 1px #94a3b8 inset;
}

::v-deep .login-page__form .el-input--large .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 2px rgba(13, 71, 161, 0.18), 0 0 0 1px #0D47A1 inset;
}

::v-deep .login-page__form .el-input--large .el-input__inner {
  font-size: 0.9375rem;
  color: #1e293b;
  font-family: 'Roboto', sans-serif;
}

::v-deep .login-page__form .el-input--large .el-input__prefix {
  color: #94a3b8;
  font-size: 18px;
  margin-right: 8px;
}

::v-deep .login-page__form .el-input--large .el-input__suffix {
  padding-right: 4px;
}

/* ── Show/Hide Password Button ── */
.show-hide-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #94a3b8;
  font-size: 18px;
  line-height: 1;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.show-hide-btn:hover {
  color: #0D47A1;
}

/* ── Options Row ── */
.login-page__options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

::v-deep .login-page__options .el-checkbox__label {
  font-size: 0.875rem;
  color: #475569;
  font-family: 'Roboto', sans-serif;
}

::v-deep .login-page__options .el-checkbox.is-checked .el-checkbox__label {
  color: #0D47A1;
}

.login-page__forgot {
  font-size: 0.875rem;
  color: #0D47A1;
  text-decoration: none;
  font-family: 'Roboto', sans-serif;
  transition: color 0.2s ease;
}

.login-page__forgot:hover {
  color: #1565C0;
  text-decoration: underline;
}

/* ── Submit Button ── */
.login-page__submit {
  margin-bottom: 0;
}

.login-page__submit-btn {
  width: 100%;
  height: 46px;
  background: #0D47A1;
  border: 1px solid #0D47A1;
  border-radius: 10px;
  color: #ffffff;
  font-size: 0.9375rem;
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(13, 71, 161, 0.25);
}

.login-page__submit-btn:hover:not(:disabled) {
  background: #1565C0;
  border-color: #1565C0;
  box-shadow: 0 4px 14px rgba(13, 71, 161, 0.35);
  transform: translateY(-1px);
}

.login-page__submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.login-page__submit-btn:disabled {
  background: #94a3b8;
  border-color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

.login-page__submit-btn i {
  font-size: 18px;
}

/* ── Card Footer ── */
.login-page__card-footer {
  padding: 16px 32px 24px;
  text-align: center;
  border-top: 1px solid #f1f5f9;
  background: #fafbfc;
}

.login-page__card-footer p {
  font-size: 0.875rem;
  color: #64748b;
  font-family: 'Roboto', sans-serif;
  margin: 0;
}

.login-page__card-footer a {
  color: #0D47A1;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.login-page__card-footer a:hover {
  color: #1565C0;
  text-decoration: underline;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .login-page__background {
    flex-direction: column;
  }

  .login-page__branding {
    min-height: auto;
    padding: 40px 24px;
    flex: none;
  }

  /* Logo grande del panel de branding, mais compacto en mobile */
  ::v-deep .login-page__logo-link .brand-logo--lg {
    --brand-logo-icon-size: 72px;
    --brand-logo-glyph-size: 56px;
    --brand-logo-text-size: 1.5rem;
  }

  .login-page__branding-text h1 {
    font-size: 1.6rem;
  }

  .login-page__branding-text p {
    font-size: 0.9rem;
  }

  .login-page__form-panel {
    width: 100%;
    padding: 24px 20px;
    min-height: auto;
  }

  .login-page__card {
    max-width: 100%;
  }

  .login-page__card-header,
  .login-page__form {
    padding-left: 20px;
    padding-right: 20px;
  }

  .login-page__card-footer {
    padding-left: 20px;
    padding-right: 20px;
  }

  .login-page__options {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>

